import React from 'react';
import { ArcStack } from '@src/core/ui';
import { Sidebars } from './sidebars';
import Maps from './maps';
import { GoHereProvider } from '@src/features/drone/context/go-here-context';
import { DronesPageViewModelProvider } from '@src/features/drone/context/drones-page-view-model';
import { useDispatch } from 'react-redux';
import { setSelectedDrone } from '@src/features/drone/redux/actions';
import { useDroneProvider } from '@src/core/features';

export const DronesPage: React.FC = () => {
  const dispatch = useDispatch();
  const { refetch } = useDroneProvider();

  React.useEffect(() => {
    refetch();
  }, [refetch]);

  React.useEffect(() => {
    return () => {
      dispatch(setSelectedDrone(null));
    };
  }, [dispatch]);

  return (
    <GoHereProvider>
      <DronesPageViewModelProvider>
        <ArcStack direction='row'>
          <Sidebars />
          <Maps />
        </ArcStack>
      </DronesPageViewModelProvider>
    </GoHereProvider>
  );
};
